import { css, styled } from '@mui/material';
import { t } from '@kc-console/core';
import IcChevronLeftSmallRegular from '@kep/kcds-icons/IcChevronLeftSmallRegular';
import IcChevronRightSmallRegular from '@kep/kcds-icons/IcChevronRightSmallRegular';

import { Button } from '../Button';

import type { CompactPaginationItemProps, CompactPaginationItemType } from './types';

function defaultRenderCompactPaginationItemLabel(type?: CompactPaginationItemType) {
  if (type === 'next') return t('ui:pagination.next');

  return t('ui:pagination.prev');
}

const CompactPaginationItem = (props: CompactPaginationItemProps) => {
  const {
    type,
    renderCompactPaginationItemLabel = defaultRenderCompactPaginationItemLabel,
    ...others
  } = props;

  if (type !== 'next' && type !== 'previous') return null;

  return (
    <Button
      {...others}
      size="md"
      variant="tertiary"
      startIcon={
        type === 'previous' && (
          <CompactPaginationItemIcon>
            <IcChevronLeftSmallRegular />
          </CompactPaginationItemIcon>
        )
      }
      endIcon={
        type === 'next' && (
          <CompactPaginationItemIcon>
            <IcChevronRightSmallRegular />
          </CompactPaginationItemIcon>
        )
      }
    >
      {renderCompactPaginationItemLabel(type)}
    </Button>
  );
};

export default CompactPaginationItem;

const CompactPaginationItemIcon = styled('div')(
  () => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    svg {
      font-size: 16px;
    }
  `,
);
